import { addModal } from 'weblite-web-modal-viewer'
import { FeatureOnboardingDialog } from './feature-onboarding-dialog'

const COMPONENT_ID = 'featureOnboardingDialog'

export function showFeatureOnboardingDialog(
  props: Omit<Parameters<typeof FeatureOnboardingDialog>[0], 'onClose'>,
) {
  return new Promise<void>(resolve => {
    addModal({ id: COMPONENT_ID, props: { ...props, onClose: resolve } })
  })
}

export default {
  [COMPONENT_ID]: {
    Component: FeatureOnboardingDialog,
  },
}
